import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import RadioService from "services/RadioService";

class ListenLive extends React.Component {
  // eslint-disable-next-line react/sort-comp
  static STREAM = window.livePage && window.livePage.radioStream;

  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      muted: false,
      artist: "...",
      title: "...",
      error: false,
    };
  }

  componentDidMount = () => {
    const { autoplay } = this.props;

    this.player = new window.Audio(ListenLive.STREAM);

    this.player.onerror = () => {
      this.setState({
        error: true,
      });
    };

    this.player.addEventListener("playing", () => {
      this.setState({
        playing: true,
      });
    });

    this.player.addEventListener("pause", () => {
      if (this.player === null) {
        return; // this.player.pause is called in the componentWillUnmount.
      }

      this.setState({
        playing: false,
      });
    });

    this.player.addEventListener("volumechange", () => {
      this.setState({
        muted: this.player.muted,
      });
    });

    if (autoplay) {
      this.player.play();
    }
    this.updateNowListening();
  };

  componentWillUnmount = () => {
    if (this.player) {
      this.player.pause();
      this.player = null;
    }
  };

  updateNowListening = async () => {
    try {
      const { artist, title } = await RadioService.nowPlaying();

      if (this.player) {
        this.setState({
          artist,
          title,
        });
      }
    } catch (error) {
      console.log(error); // eslint-disable-line no-console
    } finally {
      setTimeout(this.updateNowListening, 10 * 1000);
    }
  };

  play = () => {
    this.player.play();
  };

  pause = () => {
    this.player.pause();
  };

  mute = () => {
    this.player.muted = true;
  };

  unmute = () => {
    this.player.muted = false;
  };

  render = () => {
    const { error, playing, muted, artist, title } = this.state;
    const { onlyButton } = this.props;

    if (error) {
      return (
        <div className="radio-player">
          <div className="radio-player__now">
            <span className="radio-player__artist">
              De radiostream is even offline maar we zijn zo weer terug.
            </span>
          </div>
        </div>
      );
    }

    return (
      <div
        className={cx("radio-player", {
          "is-center": onlyButton,
        })}
      >
        <div className="radio-player__actions">
          {playing && (
            <button
              className="radio-player__button action action--pauze"
              type="button"
              onClick={this.pause}
            >
              <span className="visually-hidden">pause</span>
              <svg
                className="action__icon is-prefix"
                width="24px"
                height="24px"
              >
                <use xlinkHref="#pauze" width="24px" height="24px" />
              </svg>
            </button>
          )}
          {playing === false && (
            <button
              className="radio-player__button action action--play"
              type="button"
              onClick={this.play}
            >
              <span className="visually-hidden">play</span>
              <svg
                className="action__icon is-prefix"
                width="20px"
                height="24px"
              >
                <use xlinkHref="#play" width="20px" height="24px" />
              </svg>
            </button>
          )}
          {muted && (
            <button
              className="radio-player__button action action--unmute"
              type="button"
              onClick={this.unmute}
            >
              <span className="visually-hidden">unmute</span>
              <svg
                className="action__icon is-prefix"
                width="11px"
                height="20px"
              >
                <use xlinkHref="#unmute" width="11px" height="20px" />
              </svg>
            </button>
          )}
          {muted === false && (
            <button
              className="radio-player__button action action--mute"
              type="button"
              onClick={this.mute}
            >
              <span className="visually-hidden">mute</span>
              <svg
                className="action__icon is-prefix"
                width="20px"
                height="17px"
              >
                <use xlinkHref="#mute" width="20px" height="17px" />
              </svg>
            </button>
          )}
        </div>
        <div className="radio-player__now">
          <span className="radio-player__artist">{artist}</span>
          <span className="radio-player__song">{title}</span>
        </div>
      </div>
    );
  };
}

ListenLive.propTypes = {
  autoplay: PropTypes.bool.isRequired,
};

export default ListenLive;
